<template>
  <div class="modal-wrap">
  <h1 class="tit-h1 d-flex">
    고객정보
    <div class="ml-auto align-self-center">
      <v-icon x-small class="svg-close20" @click="[$emit('hide'),init(),selectCus()]"></v-icon>
    </div>
  </h1>
  <div class="modal-box">
      <div class="box-ct d-flex gray-box">
        <div class="d-flex align-center">
          <div class="form-inp sm">
            <v-select
              :items="ASP_CUST_KEY"
              item-value="CD"
              item-text="CD_NM"
              outlined
              hide-details
              label="회사구분"
              placeholder="선택하세요"
              v-model="ASP_NEWCUST_KEY"
              readonly
            >
              <template v-slot:label>
                회사구분
                <v-icon color="#EF9191">mdi-circle-small</v-icon>
              </template>
            </v-select>
          </div>
          <v-text-field
            class="form-inp sm ml-2"
            name="name" label="고객명" outlined hide-details
            v-model="CUS_NEWNM">

            <template v-slot:label>
              고객명
            </template>
          </v-text-field>
          <v-checkbox
            :on-icon="'svg-chk-on'"
            :off-icon="'svg-chk-off'"
            label="기업명유사검색"
            class="d-inline-flex  ml-2"
            v-model="SRH_SIM"></v-checkbox>
          <v-text-field
            class="form-inp sm ml-2"
            name="name" label="생년월일" outlined hide-details
            v-model="CUS_NEWBIRTH">

            <template v-slot:label>
              생년월일
            </template>
          </v-text-field>
          <div class="form-inp sm ml-6">
            <v-text-field
              outlined
              hide-details
              label="전화번호"
              placeholder="선택하세요"
              v-model="PHONE_NEWNUM"
            >
              <template v-slot:label>
                전화번호
              </template>
            </v-text-field>
          </div>
          <!--
          <div class="form-inp sm ml-6">
            <v-text-field
              outlined
              hide-details
              label="전화번호1"
              placeholder="선택하세요"
              v-model="PHONE_NEWNUM1"
            >
              <template v-slot:label>
                전화번호
              </template>
            </v-text-field>
          </div>
          -
          <v-text-field
            class="form-inp sm"
            name="name" label="전화번호2" outlined hide-details
            v-model="PHONE_NEWNUM2">

            <template v-slot:label>
              전화번호
            </template>
          </v-text-field>
          -
          <v-text-field
            class="form-inp sm"
            name="name" label="전화번호3" outlined hide-details
            v-model="PHONE_NEWNUM3">

            <template v-slot:label>
              전화번호
            </template>
          </v-text-field>
          -->
        </div>

        <div class="ml-auto align-self-center ">
          <v-btn
            :disabled = "nextDisabled"
              dark
              small
              class="btn-main-search pa-0 ml-2"
              min-width="32px"
              height="32px"
              plain
              @click="selectCus('next')"
            >다음</v-btn>
          <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnSearch')" outlined class="btn-etc2 ml-3" v-on:click="selectCus">조회</v-btn>
        </div>
    </div>
  <div class="mt-3">
    <v-data-table
      dense
      height="521px"
      :headers="gridDataHeaders"
      :items="gridDataText"
      :items-per-page="itemsPerPage"
      item-key="index"
      :page.sync="page"
      hide-default-footer
      class="grid-default"
      calculate-widths
      @page-count="pageCount = $event"
      @click:row="rowClick1"
      @dblclick:row="rowClick2"
      single-select
    >
    </v-data-table>
    <div class="grid-paging text-center pt-2">
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="totalVisible"
            next-icon="svg-paging-next"
            prev-icon="svg-paging-prev"
          ></v-pagination>
        </div>
        <p class="caption text-right">
          <strong class="clr-error">{{ gridDataText.length }}</strong
          >건의 고객이 검색되었습니다.
        </p>
    </div>
  </div>
  </div>
</template>

<script>
import api from '../../store/apiUtil.js';
import { mixin } from "@/mixin/mixin.js";

export default {
  name: "MENU_MP01", //name은 'MENU_' + 파일명 조합
  mixins: [mixin],
  props: {
    cusInfo: {
      type: Object,
      value:{},
    },
  },
  components: {
  },
  data() {
    return {
      gridDataHeaders: [
        {
          text: 'No',
          align: 'center',
          value: 'index',
          width: '50px',
          sortable: false,
        },
        {text:"고객구분", value: 'CUSTOMER_SECTION', align: 'center', sortable: false, },
        {text:"고객상태", value: 'CUSTOMER_STATE', align: 'center', sortable: false, },
        {text:"고객유형", value: 'CUSTOMER_TYPE_CD', align: 'center', sortable: false, },
        {text:"고객번호", value: 'CUSTOMER_PHONE_NO', align: 'center', sortable: false, },
        {text:"고객명", value: 'CUSTOMER_NM', align: 'center', sortable: false, },
        {text:"주민/사업자번호", value: 'RES_NO', align: 'center', sortable: false, }, //주민번호 뒷자리 가리기
        {text:"기본주소", value: 'OWNHOM_ADR', align: 'center', sortable: false, },
        {text:"휴대전화번호", value: 'CUSTOMER_PHONE_NO', align: 'center', sortable: false, },
        {text:"자택전화번호", value: 'OWNHOM_TEL_NO', align: 'center', sortable: false, },
        {text:"직장전화번호", value: 'WRC_TEL_NO', align: 'center', sortable: false, },
      ],
      gridDataText: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      totalVisible: 10,
      pagination: { page: 1, rowsPerPage: 500    , sortBy: "", descending: "" },

      ASP_CUST_KEY:this.$store.getters['userStore/GE_USER_ROLE'].company,

      PHONE_NUM: '',

      ASP_NEWCUST_KEY: '',
      CUS_NEWNM:'',
      SRH_SIM: '',
      CUS_NEWBIRTH:'',
      PHONE_NEWNUM:'',
      //PHONE_NEWNUM1: '',
      //PHONE_NEWNUM2: '',
      //PHONE_NEWNUM3: '',
    };
  },

  created() {
    this.ASP_NEWCUST_KEY = this.cusInfo.ASP_CUST_KEY;
    this.CUS_NEWNM = this.cusInfo.CUST_NM;
    this.ASP_CUST_KEY = this.$store.getters['userStore/GE_USER_ROLE'].company;
    this.PHONE_NEWNUM = this.cusInfo.PHONE_NUM
    /*
    if(this.cusInfo.PHONE_NUM != undefined){
      if(this.cusInfo.PHONE_NUM.length == 11){
          
          //this.PHONE_NEWNUM1 = this.cusInfo.PHONE_NUM.substr(0,3);
          //this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substr(3,4);
          //this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substr(7,4);

          this.PHONE_NEWNUM1 = this.cusInfo.PHONE_NUM.substring(0, 3);
          this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substring(3, 7);
          this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substring(7, 11);

        } else if(this.cusInfo.PHONE_NUM.length == 10) {

          //this.PHONE_NEWNUM1 = this.cusInfo.PHONE_NUM.substr(0,3);
          //this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substr(3,3);
          //this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substr(6,4);

          let phoneArea = this.cusInfo.PHONE_NUM.substring(0, 2);

          if (phoneArea == "02") {
            this.PHONE_NEWNUM1 = phoneArea;
            this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substring(2, 6);
            this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substring(6, 10);
          } else {
            this.PHONE_NEWNUM1 = this.cusInfo.PHONE_NUM.substring(0, 3);
            this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substring(3, 6);
            this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substring(6, 10);
          }
        } else if(this.cusInfo.PHONE_NUM.length == 9) {
          this.PHONE_NEWNUM1 = this.cusInfo.PHONE_NUM.substring(0, 2);
          this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substring(2, 5);
          this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substring(5, 9);
        } 
    }
    */
    this.selectCus();
  },

  methods: {
    init(){
      this.ASP_NEWCUST_KEY = this.cusInfo.ASP_CUST_KEY;

      this.CUS_NEWNM='';
      this.SRH_SIM='';
      this.CUS_NEWBIRTH='';
      //this.PHONE_NEWNUM1= '';
      //this.PHONE_NEWNUM2= '';
      //this.PHONE_NEWNUM3= '';
      this.PHONE_NEWNUM= '';
    },

    selectCus(next){
      var CHK_SEARCH = "";
      if (this.SRH_SIM == false || this.SRH_SIM == "" || this.SRH_SIM == null) {
        CHK_SEARCH = "";
      } else {
        CHK_SEARCH = this.SRH_SIM;
      }
      if (next == 'next'){
      } else {
        this.gridDataText = [];
        this.pagination.page = 1; //페이징 처리 초기화
        this.nextDisabled = true;  //버튼 비활성화
      }
      api.post("api/setting/customer/info-list/cstmrinfo-inqire-popup/inqire",   //api url입력
      {
        ASP_NEWCUST_KEY: this.ASP_NEWCUST_KEY,
        fldInqCustNm: this.CUS_NEWNM,
        fldInqCustIdfNo: this.CUS_NEWBIRTH,
        checkCF01: CHK_SEARCH,
        //cmbInqTano: this.PHONE_NEWNUM1,
        //fldInqTgno: this.PHONE_NEWNUM2,
        //fldInqTino: this.PHONE_NEWNUM3,
        ASP_USER_ID: this.$store.getters['userStore/GE_USER_ROLE'].userId,
        ASP_CUST_KEY: this.$store.getters['userStore/GE_USER_ROLE'].company[0].CD,
        CUSTOMER_PHONE_NO: this.PHONE_NEWNUM,
      },
      {head: {
        "SERVICE" : "setting.customer.info-list.cstmrinfo-inqire-popup",
        "METHOD" : "inqire",
        "TYPE" : "BIZ_SERVICE",
        "ROW_CNT" : this.pagination.rowsPerPage,
        "PAGES_CNT" : this.pagination.page,
        "PAGING" : "Y",

      }})
      .then((response) => {
        console.log(response.data.DATA);
        let tempDataText = response.data.DATA;
        let idx = this.gridDataText.length + 1;
        for(let i in tempDataText){
          tempDataText[i]["index"]= idx++;
        }
        //this.gridDataText = tempDataText;        
        this.gridDataText = [...this.gridDataText, ...tempDataText]
        //다음
        console.log('response.data.HEADER.next=',response.data.HEADER.next)
        //request에 보낸 head.PAGES_CNT와 head.ROW_CNT을 곱한값과 response.data.HEADER의 HEADER.TOT_COUNT와 비교하여 다음 조회건이 있는지 확인한다
        if(response.data.HEADER.next !== null && response.data.HEADER.next !== undefined){
          if(response.data.HEADER.next === true){
            this.nextDisabled = false //버튼 활성화
          }else{
            this.nextDisabled = true  //버튼 비활성화
          }
        }

        //이부분은 체크해볼것
        this.pagination.page += 1 
        this.page=1;
      })
      .catch((err) => {
        alert(err);
      })
    },

    //Table row 클릭이벤트
    rowClick2(e, { item }) {
      this.cusInfo.CUST_ID = item.CUSTOMER_ID;
      this.cusInfo.CUST_NM = item.CUSTOMER_NM;
      this.cusInfo.CUSTOMER_MEMO = item.CUSTOMER_MEMO;
      this.cusInfo.CUSTOMER_PHONE_NO = item.CUSTOMER_PHONE_NO;
      this.cusInfo.EMAIL = item.EMAIL;
      this.cusInfo.OWNHOM_ADR = item.OWNHOM_ADR;
      this.cusInfo.OWNHOM_DETAIL_ADR = item.OWNHOM_DETAIL_ADR;
      this.cusInfo.ATENT_CUSTOMER = item.ATENT_CUSTOMER;

      //this.cusInfo.EXTRAADDRESS = item.EXTRAADDRESS;
      //this.cusInfo.POST_CODE = item.POST_CODE;

      this.$emit("selectCus", this.cusInfo);
      //this.init();
      //this.selectCus();
    },

    //Table row 클릭이벤트
    rowClick1(item, row) {
      if(item != null){
        this.activeRow(row,true);
      }
    },

    activeRow(row, value){
      console.log(row);
      this.selectedRow = row;
      row.select(Boolean(value));
      row.isSelected = Boolean(value);
    },

  },
  mounted(){
  },
  computed: {},
  watch: {
    cusInfo(){
      
      this.gridDataText = [];
      this.init();
      
      this.ASP_CUST_KEY = this.$store.getters['userStore/GE_USER_ROLE'].company;
      this.ASP_NEWCUST_KEY = this.cusInfo.ASP_CUST_KEY;
      this.CUS_NEWNM = this.cusInfo.CUST_NM;
      this.PHONE_NEWNUM = this.cusInfo.PHONE_NUM;
      /*
      if(this.cusInfo.PHONE_NUM != undefined){
        if(this.cusInfo.PHONE_NUM.length == 11){
          
          //this.PHONE_NEWNUM1 = this.cusInfo.PHONE_NUM.substr(0,3);
          //this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substr(3,4);
          //this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substr(7,4);

          this.PHONE_NEWNUM1 = this.cusInfo.PHONE_NUM.substring(0, 3);
          this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substring(3, 7);
          this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substring(7, 11);

        } else if(this.cusInfo.PHONE_NUM.length == 10) {

          //this.PHONE_NEWNUM1 = this.cusInfo.PHONE_NUM.substr(0,3);
          //this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substr(3,3);
          //this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substr(6,4);

          let phoneArea = this.cusInfo.PHONE_NUM.substring(0, 2);

          if (phoneArea == "02") {
            this.PHONE_NEWNUM1 = phoneArea;
            this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substring(2, 6);
            this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substring(6, 10);
          } else {
            this.PHONE_NEWNUM1 = this.cusInfo.PHONE_NUM.substring(0, 3);
            this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substring(3, 6);
            this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substring(6, 10);
          }
        } else if(this.cusInfo.PHONE_NUM.length == 9) {
          this.PHONE_NEWNUM1 = this.cusInfo.PHONE_NUM.substring(0, 2);
          this.PHONE_NEWNUM2 = this.cusInfo.PHONE_NUM.substring(2, 5);
          this.PHONE_NEWNUM3 = this.cusInfo.PHONE_NUM.substring(5, 9);
        } 
      } 
      */

      this.selectCus();
    }
  }
};
</script>

<style></style>
